import { render, staticRenderFns } from "./Tzqtck.vue?vue&type=template&id=2ca7b003&scoped=true&"
import script from "./Tzqtck.vue?vue&type=script&lang=js&"
export * from "./Tzqtck.vue?vue&type=script&lang=js&"
import style0 from "./Tzqtck.vue?vue&type=style&index=0&id=2ca7b003&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7b003",
  null
  
)

export default component.exports